export default __webpack_public_path__ + "static/media/file-shredder.0d220da2.svg";